import React from 'react'
import styled from "styled-components";

const Item = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.1rem;
    border-radius: 8px;
    background-color: ${({ bgColor }) => bgColor ? bgColor : '#58B7C2'};
    color: #fff;
    height: 16.232rem;
    column-gap: 4rem;

    .achievement-text {
        font-weight: 700;
        font-size: 1.2rem;
        letter-spacing: 1px;
        /* width: 100%;
        max-width: 9.6px; */
    }

    .achievement-date {
        font-weight: 500;
        font-size: 1rem;
        margin-top: 5px;
    }
    .achievement-type {
        margin-top: 2.4rem;
        display: flex;
        align-items: center;
        

        .achievement-type-text {
            font-size: 1rem;
            font-weight: 500;
            margin-left: 9px;
        }
    }
`

const AchievementItem = ({ bgColor, achievementDate, achievementType }) => {
    return (
        <Item bgColor={bgColor}>
            <div>
                <h2 className="achievement-text">ACHIEVEMENT UNLOCKED</h2>
                <p className="achievement-date">{achievementDate}</p>
                <div className="achievement-type">
                    <img src="/assets/images/achievement-trophy.png" /> <span className="achievement-type-text">{achievementType}</span>
                </div>
            </div>
            <div>
                <img src="/assets/images/achievement-badge.png" />
            </div>
        </Item>
    )
}

export default AchievementItem
